export default "__VITE_ASSET__4hKCHwja__"